import $ from 'jquery';
import {
  createCustomWidget,
  escapeAttr,
  refinementListTemplate,
  createStatsWidget,
  createSearchBoxWidget,
  createClearAllWidget,
  createSaveSearchWidget,
  createCurrentRefinedWidget,
  createDescriptionWidget,
  createQuickListWidget,
  createPaginationWidget
} from './base_widgets';

window.Widgets = {
  refinementListTemplate,

  getCompaniesQuery(user_id, tag) {
    let query;
    const list = $('#companies-smart-lists ul#quick-lists li a.selected').data('type');
    const demoFilter = 'demo=0';

    if (list === 'follower_ids') {
      query = list + '=' + user_id;
    } else if (list === 'all-companies') {
      query = '';
    } else if (list && list.match(/^tag-/)) {
      query = '_tags:' + tag;
    } else {
      query = '';
    }
    return [demoFilter, query].filter(Boolean).join(' AND ');
  },

  quickListWidget() {
    return createQuickListWidget('#companies-smart-lists ul#quick-lists');
  },

  descriptionWidget(element, attributes, descriptionAttribute) {
    return createDescriptionWidget(element, attributes, descriptionAttribute);
  },

  clearAllWidget() {
    return createClearAllWidget();
  },

  searchBoxWidget(placeholder) {
    return createSearchBoxWidget({ placeholder: placeholder || 'Search for companies...' });
  },

  currentRefinedValuesWidget() {
    return createCurrentRefinedWidget();
  },

  statsWidget() {
    return createStatsWidget();
  },

  locationWidget() {
    return instantsearch.widgets.refinementList({
      container: '#locations',
      limit: 5,
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      operator: 'or',
      attribute: 'locations',
      sortBy: ['isRefined'],
      templates: { item: refinementListTemplate }
    });
  },

  primaryActivitiesWidget() {
    return instantsearch.widgets.refinementList({
      container: '#primary_activities',
      attribute: 'primary_activities',
      operator: 'or',
      limit: 10,
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      sortBy: ['isRefined'],
      templates: { item: refinementListTemplate }
    });
  },

  secondaryActivitiesWidget() {
    return instantsearch.widgets.refinementList({
      container: '#secondary_activities',
      attribute: 'secondary_activities',
      operator: 'or',
      limit: 10,
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      sortBy: ['isRefined'],
      templates: { item: refinementListTemplate }
    });
  },

  userTagsWidget(currentUserId) {
    return instantsearch.widgets.refinementList({
      container: '#user-tags',
      attribute: `user_tags.${currentUserId}`,
      operator: 'or',
      limit: 5,
      showMore: true,
      showMoreLimit: 5000,
      searchable: false,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      sortBy: ['isRefined', 'count:desc', 'name:asc'],
      templates: { item: refinementListTemplate }
    });
  },

  projectsLocationWidget() {
    return instantsearch.widgets.refinementList({
      container: '#projects-location',
      attribute: 'projects_location',
      operator: 'or',
      limit: 10,
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      sortBy: ['isRefined'],
      templates: { item: refinementListTemplate }
    });
  },

  projectsSectorWidget() {
    return instantsearch.widgets.refinementList({
      container: '#sectors',
      attribute: 'projects_sector',
      operator: 'and',
      limit: 10,
      showMore: true,
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      sortBy: ['isRefined'],
      templates: { item: refinementListTemplate }
    });
  },

  projectsMainSectorWidget() {
    return instantsearch.widgets.refinementList({
      container: '#project-main-sector',
      attribute: 'projects_main_sector',
      operator: 'and',
      limit: 10,
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      sortBy: ['isRefined'],
      templates: { item: refinementListTemplate }
    });
  },

  projectsBudgetWidget() {
    return instantsearch.widgets.rangeInput({
      container: '#budget-range',
      attribute: 'projects_budget',
      templates: {
        currency: '$M',
        separatorText: 'to',
        submitText: ''
      }
    });
  },

  teamSizeWidget() {
    return instantsearch.widgets.rangeSlider({
      container: '#team-size',
      attribute: 'team_size',
      step: 1,
      tooltips: {
        format(rawValue) { return Math.round(rawValue).toLocaleString(); }
      },
      pips: false
    });
  },

  certificatesWidget() {
    return instantsearch.widgets.refinementList({
      container: '#certificates',
      attribute: 'certificates',
      operator: 'or',
      limit: 10,
      sortBy: ['isRefined']
    });
  },

  projectsCountWidget() {
    return instantsearch.widgets.rangeSlider({
      container: '#projects-count',
      attribute: 'projects_count',
      step: 1,
      tooltips: {
        format(rawValue) { return Math.round(rawValue).toLocaleString(); }
      },
      pips: false
    });
  },

  companiesHitsWidget(user_id) {
    const renderHits = (renderOptions, isFirstRender) => {
      if (isFirstRender) return;
      const items = renderOptions.hits;
      if (items.length === 0) {
        return CompaniesTableView.emptyCallHandler();
      } else {
        return CompaniesTableView.reloadData(user_id, items);
      }
    };
    return instantsearch.connectors.connectHits(renderHits);
  },

  companiesGridHitsWidget(user_id) {
    user_id = parseInt(user_id, 10);

    let listClasses = 'items grid borders ais-Hits-list';
    if (user_id && (GridListToggler.getViewMode() === 'grid')) {
      listClasses += ' vertical';
    }

    return instantsearch.widgets.infiniteHits({
      container: '#companies-list-container',
      cssClasses: {
        root: 'ais-Hits',
        item: 'item',
        list: listClasses
      },
      transformItems(items) {
        return items.map(function (item) {
          item.tagged = item.user_tags[user_id];
          if (item.follower_ids.indexOf(user_id) >= 0) {
            item.liked = true;
          }
          return item;
        });
      },
      templates: {
        item: $('#company-template').text(),
        empty: function () { return $('#no-search-results-found-template').text(); }
      }
    });
  },

  paginationWidget() {
    return createPaginationWidget();
  },

  sortBySelectorWidget(sortByIndices) {
    return instantsearch.widgets.sortBy({
      container: '#sort-by-container',
      items: sortByIndices
    });
  },

  saveSearchWidget() {
    return createSaveSearchWidget();
  },

  dynamicFacetsWidget(dynamicAttributes) {
    let sortedFacetValues = [];
    const refinementListContainer = document.body.querySelector('#refinement-lists');
    // Guard: return a no-op widget if the container doesn't exist (e.g. public restricted view)
    if (!refinementListContainer) {
      return createCustomWidget({});
    }
    return {
      getWidgetUiState(uiState, widgetStateOptions) {
        const disjunctiveFacets = _.pluck(sortedFacetValues, 'name');
        return _.extend(uiState, { disjunctiveFacetsRefinements: _.pick(widgetStateOptions.helper.state.disjunctiveFacetsRefinements, disjunctiveFacets) });
      },
      getWidgetSearchParameters(searchParameters, widgetSearchParametersOptions) {
        _.each(widgetSearchParametersOptions.uiState.disjunctiveFacetsRefinements, (value, name) => searchParameters = searchParameters.toggleRefinement(name, value));
        return searchParameters;
      },
      init(options) {
        const refineElement = function (el) {
          el.setAttribute('data-refined', 'refined');
          el.setAttribute('checked', true);
        };

        const unrefineElement = function (el) {
          el.setAttribute('data-refined', 'unrefined');
          el.setAttribute('checked', false);
        };

        const _facetClickHandler = function (e) {
          const element = e.target;
          if (!element.classList.contains('refinement-list-unordered-list-item')) {
            return false;
          }
          const type = element.getAttribute('data-facet-type');
          const name = element.getAttribute('data-facet-name');
          const value = element.getAttribute('data-facet-value');
          const facetAttributeName = type + '.' + name;
          if (type === 'non_numeric_attributes') {
            options.helper.toggleRefinement(facetAttributeName, value).search();
            if (element.getAttribute('data-refined') === 'refined') { unrefineElement(element); } else { refineElement(element); }
          }
          if (type === 'numeric_attributes') {
            if (element.getAttribute('data-refined') === 'refined') {
              if (value.indexOf('-') === -1) {
                options.helper.removeNumericRefinement(facetAttributeName, '>=', parseInt(value, 10)).search();
              } else {
                options.helper.toggleRefinement(facetAttributeName, value).search();
              }
              element.setAttribute('data-refined', 'unrefined');
            } else {
              if (value.indexOf('-') === -1) {
                options.helper.addNumericRefinement(facetAttributeName, '>=', parseInt(value, 10)).search();
              } else {
                options.helper.toggleRefinement(facetAttributeName, value).search();
              }
              element.setAttribute('data-refined', 'refined');
            }
          }
        };

        refinementListContainer.addEventListener('click', _facetClickHandler);
      },
      render(options) {
        const content = options.results;
        const facetValues = content.disjunctiveFacets.map(function (facet) {
          if (facet.name.match(/numeric_attributes/g)) {
            return {
              name: facet.name,
              values: content.getFacetValues(facet.name)
            };
          }
        }).filter(Boolean);
        sortedFacetValues = facetValues.sort(function (a, b) {
          b.values.reduce(((p, c) => p + c.count), 0) - a.values.reduce(((p, c) => p + c.count), 0);
          return dynamicAttributes[a.name.split('attributes.')[1]].filter_priority - dynamicAttributes[b.name.split('attributes.')[1]].filter_priority;
        });

        const currentRefinements = content.getRefinements().map(refinementObj => refinementObj.attributeName + '.' + refinementObj.name);
        refinementListContainer.innerHTML = '';
        sortedFacetValues.map(function (facet) {
          const facetParent = facet.name.split('.')[0];
          const facetName = facet.name.split('attributes.')[1];
          const facetContainer = document.createElement('div');
          const rootList = document.createElement('div');
          const bodyList = document.createElement('div');
          const itemsList = document.createElement('div');
          const header = document.createElement('div');
          const span = document.createElement('span');
          const hiddenContent = document.createElement('div');
          facetContainer.className = 'row nomargin expandable-block filter-block';
          header.className = 'filter-block-title toggle-content-btn toggle-expand';
          span.textContent = facetName;
          hiddenContent.className = 'hidden-content';
          facetContainer.appendChild(header);
          header.appendChild(span);
          facetContainer.appendChild(hiddenContent);
          hiddenContent.appendChild(rootList);
          rootList.appendChild(bodyList);
          rootList.className = 'ais-root RefinementList';
          bodyList.className = 'ais-body ais-RefinementList-body';
          itemsList.className = 'ais-RefinementList-list';
          bodyList.appendChild(itemsList);
          refinementListContainer.appendChild(facetContainer);
          facet.values.map(function (value) {
            const listItem = document.createElement('div');
            const itemBox = document.createElement('div');
            const itemLabel = document.createElement('label');
            const itemInput = document.createElement('input');
            const itemCount = document.createElement('span');
            itemInput.className = 'refinement-list-unordered-list-item ais-RefinementList-checkbox';
            itemCount.className = 'ais-RefinementList-count';
            itemLabel.className = 'ais-RefinementList-label';
            listItem.className = 'ais-RefinementList-item';
            itemInput.setAttribute('data-facet-type', facetParent);
            itemInput.setAttribute('data-facet-name', facetName);
            itemInput.setAttribute('data-facet-value', value.name);
            itemInput.setAttribute('data-facet-count', value.count);
            itemInput.setAttribute('type', 'checkbox');
            itemInput.setAttribute('value', value.name);
            itemLabel.appendChild(itemInput);
            const textnode = document.createTextNode(value.name);
            itemCount.textContent = value.count;
            itemLabel.appendChild(itemCount);
            itemLabel.insertBefore(textnode, itemCount);
            if (currentRefinements.indexOf(facetParent + '.' + facetName + '.' + value.name) !== -1) {
              itemInput.setAttribute('data-refined', 'refined');
              itemInput.setAttribute('checked', true);
              facetContainer.className += ' expanded';
            }
            itemBox.appendChild(itemLabel);
            listItem.appendChild(itemBox);
            itemsList.appendChild(listItem);
          });
        });
      }
    };
  }
};
